"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7010],{

/***/ 9988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ useLocalizeCity; },
/* harmony export */   "Qu": function() { return /* binding */ useLocalizedCity; },
/* harmony export */   "yC": function() { return /* binding */ getLocalizedCity; }
/* harmony export */ });
/* unused harmony export getLocalizedCities */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26793);



var getLocalizedCities = function(t) {
    var citiesGermany = t("common:cities", {
        returnObjects: true
    });
    var citiesAustria = t("common:citiesAustria", {
        returnObjects: true
    });
    var citiesSwitzerland = t("common:citiesSwitzerland", {
        returnObjects: true
    });
    var citiesDenmark = t("common:citiesDenmark", {
        returnObjects: true
    });
    var citiesUK = t("common:citiesUK", {
        returnObjects: true
    });
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, citiesGermany, citiesAustria, citiesSwitzerland, citiesDenmark, citiesUK);
};
var getLocalizedCity = function(city, t) {
    return getLocalizedCities(t)[city];
};
/**
 * Returns a translate function, that translates a city key,
 * regardless of which country namespace it is under
 */ var useLocalizeCity = function() {
    var cities = useAllCity();
    var translateCity = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(city) {
        return cities[city];
    }, [
        cities
    ]);
    return translateCity;
};
var useLocalizedCity = function(city) {
    var translateCity = useLocalizeCity();
    return translateCity(city);
};
var useAllCity = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)("common").t;
    var allCities = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return getLocalizedCities(t);
    }, [
        t
    ]);
    return allCities;
};


/***/ }),

/***/ 66442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QualityAndSafetyIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62087);






function QualityAndSafetyIcon(_param) {
    var size = _param.size, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 595.28 595.28",
        height: size,
        width: size
    }, restProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#f28c0b",
                d: "M396.58 394.93a57 57 0 01-29.35 7h-7.8l-52.14 121.26L337 592.4a4.74 4.74 0 008.72 0l37.08-95.77 94.93 39.1a4.74 4.74 0 006.14-6.2L417 373.54a56.75 56.75 0 01-20.42 21.39zM283.8 425.12c-17.91 0-31.3-9.48-41.82-17.08a62.65 62.65 0 00-11.78-7 17.36 17.36 0 00-4.25-.35 58.71 58.71 0 00-10.46.63c-4.74.42-9.62.83-14.84.83a56.92 56.92 0 01-29.35-7 48.32 48.32 0 01-8.08-5.92L103 529.39a4.74 4.74 0 002.59 6.18 4.69 4.69 0 003.55 0l94.93-39.1 37.08 95.77a4.74 4.74 0 008.72 0l80-186.94-3.87 3.09c-10.9 6.97-24.29 16.73-42.2 16.73zM283.93 61.25A139.57 139.57 0 10423.5 200.82 139.57 139.57 0 00283.93 61.25z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#f28c0b",
                d: "M460.14 248.11c4.25-15.75 23.42-30.11 23.42-47.26s-19.24-31.43-23.42-47.26 4.95-38.33-3.27-52.62S424.66 83.61 413 71.83s-14.63-35.55-29.13-44-36.32 1-52.63-3.28S301.08 1.15 284 1.15s-31.43 19.17-47.25 23.42-38.34-4.95-52.63 3.28-17.36 32.2-29.14 44-35.54 14.62-43.91 29.15 1.05 36.31-3.34 52.62-23.42 30.08-23.42 47.23 19.16 31.44 23.42 47.19-5 38.34 3.34 52.63S143.21 318 155 329.8s14.64 35.55 29.14 43.91 36.32-1 52.63 3.35 30.11 23.42 47.25 23.42 31.44-19.24 47.19-23.42 38.34 4.95 52.63-3.28 17.35-32.2 29.13-43.91 35.55-14.64 44-29.14-1.15-36.31 3.17-52.62zm-176.21 112.5a159.69 159.69 0 11159.69-159.69 159.85 159.85 0 01-159.69 159.69z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M352.39 161.53c-.19 4.27-.33 8.53-.56 12.78q-.45 8.16-1.65 16.25A113.85 113.85 0 01325.45 248a151.67 151.67 0 01-17.08 17.76 217.94 217.94 0 01-20.61 16.12 6.38 6.38 0 01-7.63 0 209.36 209.36 0 01-23.86-19.06 140.24 140.24 0 01-17.44-19.49 110.8 110.8 0 01-17.3-35 130.06 130.06 0 01-3.66-16.67c-.58-3.76-1-7.54-1.37-11.33-.88-9.58-1-19.19-1.06-28.8a6.56 6.56 0 015.33-6.5 143 143 0 0025.93-7.7 180.28 180.28 0 0028.3-14.25c1.72-1.06 3.39-2.19 5.07-3.3a6.83 6.83 0 013.9-1.25 6.5 6.5 0 013.62 1.15 155 155 0 0013.65 8.32 171.69 171.69 0 0034.16 14.24c3.87 1.12 7.79 2 11.74 2.83a6.42 6.42 0 015.29 6.45v5.07c0 1.69-.04 3.28-.04 4.94zm-68.45-28.78a185 185 0 01-55.59 23.82v.89c.11 4.33.17 8.67.34 13 .13 3.09.33 6.19.61 9.28.38 4.24.89 8.47 1.63 12.67a121.09 121.09 0 002.71 12 96.44 96.44 0 0012 26.39 120.37 120.37 0 0018.24 21.54 188.31 188.31 0 0019.45 16c.2.15.41.28.6.41l.37-.25a194.11 194.11 0 0018.15-14.72 130.18 130.18 0 0015.66-17.11 97.45 97.45 0 0016.87-35 133.69 133.69 0 003.52-21.3c.36-3.89.58-7.8.75-11.7s.17-7.57.25-11.35v-.71a184.15 184.15 0 01-55.56-23.86z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M280 207.13c.21-.26.37-.5.56-.69l32.21-32.23.76-.73a4.46 4.46 0 015.9-.15c2.06 1.85 4 3.82 5.89 5.87a4.55 4.55 0 010 5.74 10.55 10.55 0 01-.72.78l-40.93 40.94a5 5 0 01-4.28 1.62 4.55 4.55 0 01-2.74-1.32l-3.65-3.54-19.88-19.51a5.15 5.15 0 01-1.6-2.76 4.47 4.47 0 011.16-4.06c1.65-1.74 3.35-3.43 5-5.14a4.86 4.86 0 016.85.06c4.92 4.9 9.9 9.73 14.85 14.58z"
            })
        ]
    }));
}


/***/ }),

/***/ 84934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_icons_Star__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85984);
/* harmony import */ var _material_ui_icons_StarBorder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83817);
/* harmony import */ var _material_ui_icons_StarHalf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74419);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26793);







function NoRatings() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)("static_pages").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__.Box, {
        display: "inline-flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__.Typography, {
            variant: "body2",
            sm: {
                textAlign: "center"
            },
            fontSize: 14,
            children: t("catererCards.noReviewsYet")
        })
    });
}
var HIGHEST_SCORE = 5;
function Rating(param) {
    var _score = param.score, score = _score === void 0 ? 0 : _score, isRated = param.isRated;
    var i18n = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)().i18n;
    var formatNumberForLocale = function(number) {
        return number.toLocaleString(i18n.languages[0], {
            minimumFractionDigits: 1
        });
    };
    var normalizedScore = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return score / 10;
    }, [
        score
    ]);
    var filledStarsArray = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return Array.from({
            length: Math.floor(normalizedScore)
        });
    }, [
        normalizedScore
    ]);
    var emptyStarsArray = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return Array.from({
            length: Math.floor(HIGHEST_SCORE - normalizedScore)
        });
    }, [
        normalizedScore
    ]);
    if (!isRated) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NoRatings, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__.Box, {
        display: "flex",
        lineHeight: 0,
        minWidth: "147px",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__.Box, {
                marginRight: 1,
                display: "flex",
                alignItems: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__.Typography, {
                    variant: "body1",
                    fontSize: 14,
                    children: formatNumberForLocale(normalizedScore)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__.Box, {
                children: [
                    filledStarsArray.map(function(_, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Star__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            color: "secondary",
                            fontSize: "small"
                        }, index);
                    }),
                    normalizedScore % 1 !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_StarHalf__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        color: "secondary",
                        fontSize: "small"
                    }),
                    emptyStarsArray.map(function(_, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_StarBorder__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            color: "secondary",
                            fontSize: "small"
                        }, index);
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Rating);


/***/ }),

/***/ 97010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TopCaterersCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ChevronRight.js
var ChevronRight = __webpack_require__(66735);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/shared/helpers/cities.js + 1 modules
var cities = __webpack_require__(6619);
// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/shared/hooks/useCurrencySymbol.js
var useCurrencySymbol = __webpack_require__(11162);
// EXTERNAL MODULE: ./src/shared/hooks/useLocalizeCity.js
var useLocalizeCity = __webpack_require__(9988);
// EXTERNAL MODULE: ./src/shared/hooks/useLocalizedFieldName.js
var useLocalizedFieldName = __webpack_require__(25734);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(62087);
;// CONCATENATED MODULE: ./src/shared/svg/Delivery.js





function Delivery(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 18 16"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 1.25C0 0.835786 0.335786 0.5 0.75 0.5H12C12.4142 0.5 12.75 0.835786 12.75 1.25V11C12.75 11.4142 12.4142 11.75 12 11.75H0.75C0.335786 11.75 0 11.4142 0 11V1.25ZM1.5 2V10.25H11.25V2H1.5Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.25 5C11.25 4.58579 11.5858 4.25 12 4.25H15C15.1989 4.25 15.3897 4.32902 15.5303 4.46967L17.7803 6.71967C17.921 6.86032 18 7.05109 18 7.25V11C18 11.4142 17.6642 11.75 17.25 11.75H12C11.5858 11.75 11.25 11.4142 11.25 11V5ZM12.75 5.75V10.25H16.5V7.56066L14.6893 5.75H12.75Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.125 11.75C3.50368 11.75 3 12.2537 3 12.875C3 13.4963 3.50368 14 4.125 14C4.74632 14 5.25 13.4963 5.25 12.875C5.25 12.2537 4.74632 11.75 4.125 11.75ZM1.5 12.875C1.5 11.4253 2.67525 10.25 4.125 10.25C5.57475 10.25 6.75 11.4253 6.75 12.875C6.75 14.3247 5.57475 15.5 4.125 15.5C2.67525 15.5 1.5 14.3247 1.5 12.875Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.875 11.75C13.2537 11.75 12.75 12.2537 12.75 12.875C12.75 13.4963 13.2537 14 13.875 14C14.4963 14 15 13.4963 15 12.875C15 12.2537 14.4963 11.75 13.875 11.75ZM11.25 12.875C11.25 11.4253 12.4253 10.25 13.875 10.25C15.3247 10.25 16.5 11.4253 16.5 12.875C16.5 14.3247 15.3247 15.5 13.875 15.5C12.4253 15.5 11.25 14.3247 11.25 12.875Z"
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/shared/svg/LeadTime.js





function LeadTime(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "18",
        height: "17",
        viewBox: "0 0 18 17",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.00016 2.12504C5.47935 2.12504 2.62516 4.97923 2.62516 8.50004C2.62516 12.0209 5.47935 14.875 9.00016 14.875C12.521 14.875 15.3752 12.0209 15.3752 8.50004C15.3752 4.97923 12.521 2.12504 9.00016 2.12504ZM1.2085 8.50004C1.2085 4.19682 4.69694 0.708374 9.00016 0.708374C13.3034 0.708374 16.7918 4.19682 16.7918 8.50004C16.7918 12.8033 13.3034 16.2917 9.00016 16.2917C4.69694 16.2917 1.2085 12.8033 1.2085 8.50004Z",
                fill: "#007F33"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.00016 3.54171C9.39136 3.54171 9.7085 3.85884 9.7085 4.25004V8.06227L12.1503 9.28315C12.5002 9.45811 12.642 9.88358 12.467 10.2335C12.2921 10.5834 11.8666 10.7252 11.5167 10.5503L8.68339 9.13359C8.44341 9.01361 8.29183 8.76834 8.29183 8.50004V4.25004C8.29183 3.85884 8.60896 3.54171 9.00016 3.54171Z",
                fill: "#007F33"
            })
        ]
    }));
}

// EXTERNAL MODULE: ./src/shared/svg/QualityAndSafetyIcon.tsx
var QualityAndSafetyIcon = __webpack_require__(66442);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/TopCaterers/Rating.js
var Rating = __webpack_require__(84934);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/TopCaterers/TopCaterersCard.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  box-shadow: 0px 4px 40px rgba(62, 41, 29, 0.08);\n  border-radius: ",
        "px;\n\n  img {\n    width: 100%;\n    display: block;\n    position: relative;\n    transition: transform 0.5s ease, filter 0.5s ease;\n  }\n\n  &:hover img {\n    filter: brightness(0.85);\n    transform: scale(1.1);\n  }\n\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: inherit;\n  color: inherit;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  &:hover .btn-caterer {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-height: 200px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  padding: ",
        ";\n  min-height: 145px;\n  ",
        " {\n    min-height: 160px;\n  }\n  ",
        " {\n    min-height: fit-content;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: 40px;\n    background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff);\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: black;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 172.5%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  margin: ",
        ";\n  height: 18px;\n  width: 0px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 42px;\n  border-radius: 0px;\n  font-size: 14px;\n\n  & > .btn-caterer__icon {\n    position: relative;\n    transition: ",
        ";\n    right: 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: ",
        "px;\n\n  ",
        " {\n    display: flex;\n    align-items: start;\n    flex-direction: column;\n  }\n  ",
        " {\n    display: inline;\n    align-items: center;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-bottom: ",
        "px;\n  }\n  ",
        " {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: ",
        "px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  min-height: ",
        "px;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: ",
        "px;\n  right: ",
        "px;\n  padding: ",
        ";\n  height: 28px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f5f5f5;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
















var CARD_WIDTH = 280;
function TopCaterersCard(param) {
    var caterer = param.caterer, providedCity = param.city;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var localizedFieldAlgolia = (0,useLocalizedFieldName/* default */.Z)().localizedFieldAlgolia;
    var city = providedCity || caterer.cities[0];
    var localizedCity = (0,useLocalizeCity/* useLocalizedCity */.Qu)(city);
    var url = (0,urls/* marketplaceURL */.j5)("/catering/".concat((0,cities/* findCitySlug */.r$)(city), "/").concat(caterer.slug));
    var currencySymbol = (0,useCurrencySymbol/* useCurrencySymbol */.m)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
        href: url,
        target: "_blank",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopCaterersCard, {
            as: "article",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                            children: caterer.profile_image && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "",
                                height: 200,
                                width: CARD_WIDTH,
                                src: caterer.profile_image,
                                objectFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPill, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                lineHeight: 1,
                                variant: "caption",
                                children: localizedCity
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CatererInformationWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CatererInformation, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitleTypography, {
                                children: caterer.company_name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SloganTypography, {
                            variant: "body2",
                            children: caterer[localizedFieldAlgolia("slogan")]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                            display: "flex",
                            alignItems: "center",
                            my: 1.5,
                            mb: 2,
                            children: [
                                caterer.quality_safety_rating === "Quality Proven Partner" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QualityAndSafetyIcon/* default */.Z, {
                                            fontSize: "small"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                    score: caterer.rating_score,
                                    isRated: caterer.is_rated
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliverInfoContainer, {
                            display: "inline",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryBox, {
                                    display: "inline-flex",
                                    fontSize: 18,
                                    ml: 0.2,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Delivery, {
                                            htmlColor: "#537124",
                                            fontSize: "inherit"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTypography, {
                                            variant: "caption",
                                            fontSize: 12,
                                            ml: 1,
                                            mr: 1.5,
                                            children: caterer.minimum_delivery_fee === 0 ? t("catererCards.freeDelivery", {
                                                amount: wholeNumberWithCurrencySymbol(caterer.minimum_delivery_fee, currencySymbol)
                                            }) : t("catererCards.delivery", {
                                                amount: wholeNumberWithCurrencySymbol(caterer.minimum_delivery_fee, currencySymbol)
                                            })
                                        })
                                    ]
                                }),
                                caterer.numeric_lead_time && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    fontSize: 18,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadTime, {
                                            htmlColor: "#537124",
                                            fontSize: "inherit"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTypography, {
                                            variant: "caption",
                                            ml: 1,
                                            children: t("catererCards.leadTime", {
                                                days: caterer.numeric_lead_time,
                                                count: caterer.numeric_lead_time
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CatererFooter, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink, {
                        size: "lg",
                        rounded: false,
                        variant: "tertiary",
                        className: "btn-caterer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "btn-caterer__copy",
                                children: t("catererCards.seeCaterer")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                                className: "btn-caterer__icon"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function wholeNumberWithCurrencySymbol(number, currencySymbol) {
    return "".concat(Math.floor(number / 100)).concat(currencySymbol);
}
var InfoTypography = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.grey.secondary;
});
var StyledTopCaterersCard = styled_components_browser_esm["default"].div(_templateObject1(), CARD_WIDTH, function(props) {
    return props.theme.spacing(1.5);
});
var StyledLink = styled_components_browser_esm["default"].a(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.grey[600];
}, function(param) {
    var theme = param.theme;
    return theme.palette.common.white;
});
var ImageWrapper = styled_components_browser_esm["default"].div(_templateObject3());
var CatererInformation = styled_components_browser_esm["default"].div(_templateObject4(), function(props) {
    return props.theme.spacing(2);
});
var CatererInformationWrapper = styled_components_browser_esm["default"].div(_templateObject5(), function(props) {
    return props.theme.spacing(0, 2);
}, function(props) {
    return props.theme.breakpoints.down("md");
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var TruncatedTypography = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject6());
var CardTitleTypography = (0,styled_components_browser_esm["default"])(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedTypography, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        variant: "h4",
        component: "h3",
        fontSize: "18px"
    }));
})(_templateObject7());
var Divider = styled_components_browser_esm["default"].div(_templateObject8(), function(props) {
    return props.theme.palette.grey[400];
}, function(props) {
    return props.theme.spacing(0, 2, 0, 1.5);
});
var ButtonLink = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject9(), function(props) {
    return props.theme.transitions.create("right", {
        duration: "250ms"
    });
});
var DeliverInfoContainer = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(props) {
    return props.theme.breakpoints.down("md");
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var DeliveryBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject11(), function(props) {
    return props.theme.breakpoints.down("md");
}, function(props) {
    return props.theme.spacing(0.5);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0);
});
var CatererFooter = styled_components_browser_esm["default"].footer(_templateObject12(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var SloganTypography = (0,styled_components_browser_esm["default"])(TruncatedTypography)(_templateObject13(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(0.5);
});
var StyledPill = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject14(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(0.5, 1);
}, function(props) {
    return props.theme.spacing(8);
});


/***/ })

}]);